import { render, staticRenderFns } from "./EditarNomeAdministradorUnidade.vue?vue&type=template&id=89a952fa"
import script from "./EditarNomeAdministradorUnidade.vue?vue&type=script&lang=js"
export * from "./EditarNomeAdministradorUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports